module.exports = __webpack_public_path__ + "assets/images/7344341d3846add3f7a17448c1d81678.avif";